import { render, staticRenderFns } from "./ManagementCardGroup.vue?vue&type=template&id=0fffb656"
import script from "./ManagementCardGroup.vue?vue&type=script&lang=js"
export * from "./ManagementCardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports